<template>
  <div class="home-view">
    <!-- 主图片 全宽 -->
    <el-row class="home-row1">
      <div v-if="images && images.home_carousel">
        <el-carousel :height="$wd.w < 500 ? '150px' : '400px'" :interval="5000" arrow="always">
          <el-carousel-item v-for="(item, index) in images.home_carousel" :key="'home_carousel' + index">
            <img @click="$tool.open(item.linkUrl)" :src="$baseURL + '/common/service/getFile/' + item.url" :alt="item.name"
              style="width: 100%; height: 100%; object-fit: cover; object-position: center; display: block">
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-row>
    <!-- 四个信息 定宽 1600-->
    <el-row class="home-row2">
      <el-col :lg="{span: 4, offset: 4}" :sm="{span: 5, offset: 2}" :xs="{span: 6}">
        <div class="pic hidden-xs-only">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAArCAMAAAANOCvQAAACQ1BMVEUAAAAAAAD/AAD/gAAAAABAQEAzMzMkJCQgICD/YEA5OTkzMzP/Zk0qKir/akA7Ozs3Nzf/bUkzMzP/cEAtLS3/aUv/cUc2Njb/a0NZMzNZQDP/bUkuLi7/b0NVQDUzMzP/cEcvLy8zMzP/bkQwMDD/cEg2Njb/bEY1NTX/akf/b0gzMzP/bE0vLy//a0c2NjY1NTX/cEozMzP/a0cyMjL/bEo0NDT/bUc0NDQzMzMyMjIxMTH/b0oxMTH/bkf/bksyMjL/bEk9NTX/bUn/b0g1NTX/bUf8bUn/bUk0NDQzMzPcZEPZY0bXYULXYUUzMzPSYETVYETSX0MyMjLNXkPLXULJXEEzMzPHXkMyMjLFXULDXEK+W0G8WkC4WD+3V0G1V0BCODOxVkAzMzOvVT+vVz+tVz83NDRDNzSqVUAzMzMyMjKgUT2fUT+dUD6cUT4zMzMyMjI0NDQzMzMyMjIzMzMzMzM0NDQ0NDQzMzNrQjgzMzMyMjIzMzNnQjgyMjI/NzQyMjJhQDgzMzMyMjJaPzczMzMyMjJTPTcyMjJVPTY5NDNROzZQOzVQOjU0NDROOjZOOzZPOzYzMzNJOjU0NDQzMzMzMzMyMjIzMzMzMzNFODQzMzMzMzM8NjQzMzMzMzMyMjIzMzI6NDM7NjQyMjIzMzMzMzM8NjMzMzM8NTMzMzMzMzMzMzMzMzM2MzM5NTMzMzM4NDQzMzM3NDQyMjIzMjIzMzM2MzMzMzM2NDMzMzMzMzMzMzMyMjIzMzMzMzMqNpcvAAAAwHRSTlMAAQECAwQFBwgICQoKDAwNDg4PEBEREhMTFBQVFhcYGRkbHh4gICEhIiQnKCgrKy8wMDIyMzQ2Njs8PT4+P0FBQkJDRkdIS01NVFVXWFlZWlpaW1xcXV5fX2BgYWJjZWZnaGhpaWlqa2tsb3BxcnN0eYCAh4mQkpiZm5ucnZ+foqKjqKqsr7Cxtba4ub2/wMHCwsLJysvMz9DQ0dLV1tbY2dra29vf4uPk5ebn6uvs7u7w8fLy8/P09PX29/r8/f5PW8cOAAACA0lEQVRIx8XS+V8MYQAG8Kk2YqVLCpFKKpSjRQcqR21qlSSkhCJXcuQI6STrSHTn2Aq7qBAqtrZ5/rR2jnd3m5mdbT6f5Pltnne+M+9FUU6z407/X/CZNDVlulEuoq6nMTMd0S5EG/PWyCCfEeZpeKMsqQEmrofZn8NvTgKGhTJiyxQmkmZWB6zmsgy5BVwTdlVAjwzphiVI2K0H6GXOyRCM4nIciHVOfqFPXH4DNPNNPE/oBy38KdP3Z0M2GxxvhkXFE9Xt5sdsLolI4ihz876YuBhvkL/sJh+h1wlI6DBgyvESryVkiCdGtYBUA5/CJJfvu03DxlcwMa9x0AnKdiwJ6FK4yQeBWoXkCHB3/ojah423A1ngz3VqaVI6xR9C52JCgkzkPhyTJC9tF0ZDSLKt0kuS1N53bAyNnoSoHrzluq4EEXmyNdD18gO+O5KnWm1aXLC7DAnYkKL9KSDW7N8es9xDTNz9IuP3MeMShEn6np1xUWtXjWFg0ZKlgasjNsXvSidjTggfMz5rRZkLklFRyeZqlp0UcFXlFWnyiBzbj2xCCs2ka5Akb2xHfZGQClvVLknKWl6zefXQPrF7rVz3ouQ/7tg/JW5ryoHn+UcLjheeLCo+VXL67LnzxXlmfM22RqfTHWJymEnub2DvyhUU9QwKU0f9UUrM1Jn3HxXlw4VpwGtlo2094jUAAAAASUVORK5CYII="
            alt="">
        </div>
        <div class="text">
          <div class="topText">{{homeCount.enterCount}}</div>
          <div class="bottomText">已注册企业</div>
        </div>
      </el-col>
      <el-col :lg="{span: 4}" :sm="{span: 5}" :xs="{span: 6}">
        <div class="pic hidden-xs-only">
          <img
            src="data:image/png;base64,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"
            alt="">
        </div>
        <div class="text">
          <div class="topText">{{homeCount.userCount}}</div>
          <div class="bottomText">已注册用户</div>
        </div>
      </el-col>
      <el-col :lg="{span: 4}" :sm="{span: 5}" :xs="{span: 6}">
        <div class="pic hidden-xs-only">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAxCAMAAAB50NBIAAABs1BMVEUAAAAAAAAAAABVVVX/VVVAQEAzMzP/ZjMkJCT/YEA5OTn/cTkzMzP/dEY3Nzf/bUn/ZkQwMDAtLS1jRzn/a0P/Zk3/c03/cEc3Nzf/bUkzMzP/bkwwMDD/bEb/bUn/bkz/a0r/b0j/bEb/cEs3Nzf/bUk1NTX/a0f/cUc0NDT/bkb/bkv/akX/cEr/bkb/akj/bUf/b0oxMTH/a0j/bEn/bUcxMTH/a0b/b0r/bUn/bkf/bkv/bEn/a0j/bkj/bUf/a0r/b0r/bEj/b0j/bEn/bkj/a0r/b0r/bUkyMjLsZ0jkZEYzMzPNXkMyMjKsVkCqVUCoVD+fUT+XUD2VTz4zMzOSTT0yMjKLTDwzMzMzMzODSTp6RzozMzMzMzMzMzMyMjJePzczMzNaPzdVPDYzMzNMOjZKOTYzMzM0MzMzMzMzMzMzMzM6NTMyMjIzMzMzMzMzMzMzMzNBNjQzMzM/NjMzMzM/NjQzMzMzMzM+NjQ+NjM8NTMzMzMzMzM7NjM7NTMzMzM5NTQzMzMzMzMzMzMzMzM0MzMzMzM0MzMzMzM0MzM0MzMzMzMzMjIzMzMzMzPD1wdfAAAAkHRSTlMAAQIDAwQFBQcICQkKCw4ODxAREhMUFBkcHB4eICEjJSYnKCkqKisrKywsLDAwMzU2Nzk5Oz0+Pj4/QUFCQ0NERUVHR0lKTExNUVJUWlxra2xtcnZ4eXp/f4GChIyNkZKTnquvt7nFyM3O0NPU1NXV1tjZ3N3f4ODh4uPk5ebp6err7fL29/n5+vr7+/z9/v5poooXAAABnklEQVRIx+2WZ08CQRCGF3tFwd4ACxbs2Lui4GHHXrErir0gqFgQT2zs/GRvMaCR4+5ITIzR58vMhyeXTebdnUOIIJ4y08AJbZ4So3dKbCAAW4lHllqZHvPAKFYpsWcB7Po4xEmc3g4wS7o9wGrEixrDHqn3cIQEcAROUjCYhNgmwH/OXjioRyjzkGXmT0t+tgRgBaEh1oi8Rny1ReuuAebb+ywZoY0s5476n84P2OHhoYQQgshD4Jxkn7AM3jUTVE5uEXtO0rdpf+4mvikn8WmK8pqWrh6dTqtpratU5aREBrATZFU9lB+9TUXJfnZifhsVkHZZ2Cc7LKuB4qZz12tvyTUUL8eMHWO85X628fn8h73I/8zjSZ99JWArrPnsVzjlPu4wwMZvtEeCsg0Amz7bCQ5uexDgzNNcMFtqB/AYt34N2MCUUTezAWcAHHN9XPYqwOV4//QN2a4SCzOsl4eHZ3dAvCMlm7vAAsKwFZLAJi2fPvKqT74/jmh5VbNG20vptN0dLY211RVlpco8hSJPWVyqUubKMlJjvXf2DS6cKRXuwKC2AAAAAElFTkSuQmCC"
            alt="">
        </div>
        <div class="text">
          <div class="topText">{{homeCount.buyCount}}</div>
          <div class="bottomText">近期预约下单</div>
        </div>
      </el-col>
      <el-col :lg="{span: 4}" :sm="{span: 5}" :xs="{span: 6}">
        <div class="pic hidden-xs-only">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAArCAMAAADmD5DTAAACLlBMVEUAAAAAAAAAAABVVVX/VVVAQEAzMzMqKir/bUk5OTkzMzMnJyf/Yk4zMzMwMDAtLS0xMTH/aEY3NzczMzMxMTEvLy//bkwxMTEwMDD/cEguLi6TTT41NTWwVT7/bEoyMjIxMTEwMDA0NDSGSjz/a0g1NTX/bkY0NDT/bkg0NDT/bEj/bksxMTH/bUfaZEb/bEg0NDT/bEkzMzP/bUcyMjL/a0ryakb8bUn/bUn4bEg0NDQzMzPyaUYyMjI0NDTmZUc0NDQ1NTU0NDTXYULSYETVYETPX0PHW0PCXUIyMjLDXEI0NDSnUz6+W0HBW0G6WUK3V0EyMjI0NDS1WUCsVkCZUD2qVUBXPjefUT9+STybUT0yMjI0NDR+SDqJTDyISzszMzMyMjIyMjI0NDQzMzMzMzMzMzNtQzp3RzozMzM0NDQyMjI0NDQzMzM0NDRsQzk0NDRlQTdhPzgzMzMyMjIzMzNYPjczMzMzMzNaPjdWPTdXPTZYPThVPDczMzNVPDYzMzNQOzUyMjJQOjUyMjJPOjZOOjY0NDQ0NDQzMzMzMzNIODRIOTQzMzNHOTUzMzNFODVCODQzMzMzMzMyMjJCNzU3NDQzMzMzMzMzMzMzMzM9NjQyMjIzMzMzMzMzMzM8NTQzMzM7NTQ5NTQzMzMzMzMzMzM0MzM1MzM3NDQzMjIzMzM2MzM2NDMzMzM2MzM0MzMzMzMzMzMzMzMzMzM0MzMyMjIzMzIzMzMzMzO/j5YhAAAAuXRSTlMAAQIDAwQFBgcJCg0NDxARFRYXGRobHh8gICEhIi0tLi8wNjc5Ojo7PEBAQUNERUdJSUtLTExNTU1OT1BQUlNTVFdYWVpaW19gYWFiYmJiZGZnZ2drbGxvcnN1dnaAgIGDhIWFhoeNjZCSk5SUlZiZoqKlpqerra6vsLGzs7a4uLm/wMDBwcLFxsfJzMzOzs/T19jZ2tre3+Dh4uPk5OXm5ufq7O3v8PLy8vP09PT19fj5+vv8/P39/g7DDFkAAAI3SURBVEjH1dXpV0xxGMDxZ2IwtqKyE9l3UjxIRbaso7IT2SNrpayRqOxLtDAoWbPlzoz5/ndeTKYm987cXvq+uue5v8+5v3vPPecnIiIpJY0dRKujsSRFgsVXYbeqeBGRxGbs15wo4qgBb9EkV59ouSYWeaHGIRngXS72WuaFDCmH02K3U1AuryHZtkiGV2JAnMX9g9+P9pjEgSFArDkY5ycwPXwUC0QQR4Dq3oh+LQALeiEyAHjksC9uQFk7rLItxvgh6RDUO6OI0CYOQ50MbYPciCL+2fuZwStnC+SI7AOPK5IohLvBqxXwYaCIywN7I4iYJmCqiIhch2IRkVxoG2It5gCUiYiM8kOSiIizHgqtxTkAY2Rwe3XB2UpoH24lBrVDCxwTcb6BnM6P9wBOWomN8GInfJo3ez98zUxbtHD+3FkzdkPH5GGD+/YU2542NHyBC+nv4Kzeh6v6t8fwubX15fFpE0aPDYkBIz4CEHDreXi79TfsCIk9AQB+qGp2pxg/JU1vAnBbdc1PeA5PtKtrANzqJrJVVTe43e7NqqqVAJzoJnRdXl7eFu0pQuUHgG+Zapa50IfAFbUWBqwNHxfQ/b3DWg2GeGBX+HjJPe6YA90OHqn4dwtL11sAvQwVkgW+A2qvAh9kiaMWfJfy06MuX7zpog9qHaHTIBCt0GkgklBt+/ioTuj8aVNLm2ycak2lqfJfFOO0KsZ0vaPMb/nWxhkzkRjpQwX6mz2j1LAEv4q71v0B/YFk1/qC2O8AAAAASUVORK5CYII="
            alt="">
        </div>
        <div class="text">
          <div class="topText">{{homeCount.orderCount}}</div>
          <div class="bottomText">近期交易达成</div>
        </div>
      </el-col>
    </el-row>

    <AnnouncementBar />

    <!-- 新闻动态 定宽 1600-->
    <el-row class="home-row3">
      <el-col :lg="{span: 9, offset: 2}">
        <div class="titleLine">
          <div class="title">新闻动态</div>
        </div>
        <div class="content">
          <div v-if="images && images.home_news_carousel">
            <el-carousel :height="$wd.w < 500 ? '200px' : '400px'" :interval="5000" arrow="always">
              <el-carousel-item v-for="(item, index) in images.home_news_carousel" :key="'home_news_carousel' + index">
                <img @click="$tool.open(item.linkUrl)" :src="$baseURL + '/common/service/getFile/' + item.url" :alt="item.name"
                  style="width: 100%; height: 100%; object-fit: cover; object-position: center; display: block">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </el-col>
      <el-col :lg="{span: 11}">
        <div class="titleLine">
          <div class="more" @click="$router.push('/news/centerNews')">更多...</div>
        </div>
        <div class="content" style="height: 400px">
          <div v-for="(item, index) in centerNews" :key="index" class="news-item" @click="openWindow('publish',item.id)" :style="{color: item.top === 1 ? 'red' : 'balck'}">
            <div class="news-item-title" :title="item.title"><i class="el-icon-caret-right"></i> {{item.title}}</div>
            <div class="news-item-date">{{$date.formatTimestamp('date', item.publishTime)}}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 培训服务 定宽 1600-->
    <el-row class="home-row4">
      <el-col :lg="{span: 9, offset: 2}">
        <div class="titleLine">
          <div class="title">培训服务</div>
          <div class="more" @click="$router.push('/lesson/classes')">更多...</div>
        </div>
        <div class="train-content">
          <div class="listContent">
            <div class="list-item" v-for="(item, index) in lessonList" :key="index">
              <div @click="openWindow('classes',item.id)">
                <div class="leftText" style="background-color: #1cb833;" v-if="item.detail.deadline > new Date().getTime()">正在报名</div>
                <div class="leftText" style="background-color: #f84a00;" v-else>报名结束</div>
                <div class="listInfo">
                  <div class="list-item-title" :title="item.name"><i class="el-icon-caret-right"></i>{{item.name}}</div>
                  <div class="list-item-text">课程时间：{{$date.formatTimestamp('date', item.detail.start)}} ~ {{$date.formatTimestamp('date', item.detail.end)}}</div>
                  <div class="list-item-text">地点：{{item.detail.address}}</div>
                  <div class="list-item-text">证书类别：{{lessonType[item.type - 1].name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :lg="{span: 11}">
        <div>
          <div class="titleLine">
            <div class="title">中心公告</div>
            <div class="more" @click="$router.push('/news/centerAnnouncement')">更多...</div>
          </div>
          <div class="content">
            <div v-for="(item, index) in centerAnnouncement" :key="index" class="news-item" @click="openWindow('publish',item.id)"
              :style="{color: item.top === 1 ? 'red' : 'balck'}">
              <div class="news-item-title" :title="item.title"><i class="el-icon-caret-right"> </i> {{item.title}}</div>
              <div class="news-item-date">{{$date.formatTimestamp('date', item.publishTime)}}</div>
            </div>
          </div>
        </div>
        <div>
          <div class="titleLine">
            <div class="title">机构公告</div>
            <div class="more" @click="$router.push('/news/institutionAnnouncement')">更多...</div>
          </div>
          <div class="content">
            <div v-for="(item, index) in institutionAnnouncement" :key="index" class="news-item" @click="openWindow('publish',item.id)"
              :style="{color: item.top === 1 ? 'red' : 'balck'}">
              <div class="news-item-title" :title="item.title"><i class="el-icon-caret-right"> </i> {{item.title}}</div>
              <div class="news-item-date">{{$date.formatTimestamp('date', item.publishTime)}}</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 安全评估检测公共服务平台 -->
    <template v-if="product != null">
      <el-row class="home-row5">
        <!-- 增加 xs/sm/md 断点，lg 保持原逻辑 -->
        <el-col :xs="24" :sm="{span:22, offset:1}" :md="{span:20, offset:2}" :lg="{span:20, offset:2}">
          <div class="titleLine">
            <div class="title">安全评估检测公共服务</div>
            <div class="arrow-more hidden-xs-only" @click="$router.push('/product/tool')"><i class="el-icon-right"></i>功能安全在线工具集介绍</div>
            <div class="arrow-more hidden-sm-and-up" @click="$router.push('/product/tool')">更多...</div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="{span:22, offset:1}" :md="{span:20, offset:2}" :lg="{span:20, offset:2}">
          <!-- 关键：去掉 style="height: 440px; overflow: hidden;" -->
          <div class="product-list">
            <div class="product-item" v-for="(item, index) in product.tool.slice(0, 12)" :key="index" @click="openWindow('purchase',item.id)">
              <div class="imgBox" v-if="item.pic">
                <img :src="$baseURL + '/common/service/getFile/' + item.pic" alt="">
              </div>
              <div class="titleBox">{{item.name}}</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 功能安全 -->
      <el-row class="home-row6">
        <el-col :xs="24" :sm="{span:22, offset:1}" :md="{span:20, offset:2}" :lg="{span:20, offset:2}">
          <div class="titleLine">
            <div class="title">功能安全服务</div>
          </div>

          <div class="subTitleLine">
            <div class="devider"></div>
            <div class="title hidden-xs-only" style="padding-right: 394px;"><span>系统级功能安全服务</span></div>
            <div class="title hidden-sm-and-up" style="padding-right: 100px; font-size: 16px"><span>系统级功能安全服务</span></div>
            <div class="arrow-more hidden-xs-only" @click="$router.push('/product/sfs')" style="background-color: #e9f8f5;"><i class="el-icon-right"></i>系统级功能安全评估检验服务介绍</div>
            <div class="arrow-more hidden-sm-and-up" @click="$router.push('/product/sfs')" style="background-color: #e9f8f5; font-size: 14px"><i class="el-icon-right"></i>更多...
            </div>
          </div>

          <!-- 去掉固定高度与隐藏 -->
          <div class="product-list">
            <div class="product-item" v-for="(item, index) in product.sfs.slice(0, 6)" :key="index" @click="openWindow('purchase',item.id)">
              <div class="imgBox" v-if="item.pic">
                <img :src="$baseURL + '/common/service/getFile/' + item.pic" alt="">
              </div>
              <div class="titleBox">{{item.name}}</div>
              <div class="subName">{{item.subName}}</div>
            </div>
          </div>

          <div class="subTitleLine">
            <div class="devider"></div>
            <div class="title hidden-xs-only" style="padding-right: 394px;"><span>产品级功能安全服务</span></div>
            <div class="title hidden-sm-and-up" style="padding-right: 100px; font-size: 16px"><span>产品级功能安全服务</span></div>
            <div class="arrow-more hidden-xs-only" @click="$router.push('/product/pfs')" style="background-color: #e9f8f5;"><i class="el-icon-right"></i>产品级功能安全评测认证服务介绍</div>
            <div class="arrow-more hidden-sm-and-up" @click="$router.push('/product/pfs')" style="background-color: #e9f8f5; font-size: 14px"><i class="el-icon-right"></i>更多...
            </div>
          </div>

          <div class="product-list">
            <div class="product-item" v-for="(item, index) in product.pfs.slice(0, 6)" :key="index" @click="openWindow('purchase',item.id)">
              <div class="imgBox" v-if="item.pic">
                <img :src="$baseURL + '/common/service/getFile/' + item.pic" alt="">
              </div>
              <div class="titleBox">{{item.name}}</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 信息安全服务 -->
      <el-row class="home-row7">
        <el-col :xs="24" :sm="{span:22, offset:1}" :md="{span:20, offset:2}" :lg="{span:20, offset:2}">
          <div class="titleLine">
            <div class="title">信息安全服务</div>
            <div class="arrow-more hidden-xs-only" @click="$router.push('/product/sis')"><i class="el-icon-right"></i>信息安全评测认证服务介绍</div>
            <div class="arrow-more hidden-sm-and-up" @click="$router.push('/product/sis')">更多...</div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="{span:22, offset:1}" :md="{span:20, offset:2}" :lg="{span:20, offset:2}">
          <div class="product-list">
            <div class="product-item" v-for="(item, index) in [].concat(product.sis, product.cis).slice(0, 6)" :key="index" @click="openWindow('purchase',item.id)">
              <div class="imgBox" v-if="item.pic">
                <img :src="$baseURL + '/common/service/getFile/' + item.pic" alt="">
              </div>
              <div class="titleBox">{{item.name}}</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 软件测试服务 -->
      <el-row class="home-row8">
        <el-col :xs="24" :sm="{span:22, offset:1}" :md="{span:20, offset:2}" :lg="{span:20, offset:2}">
          <div class="titleLine">
            <div class="title">软件测试服务</div>
            <div class="arrow-more hidden-xs-only" @click="$router.push('/product/st')"><i class="el-icon-right"></i>软件测试服务介绍</div>
            <div class="arrow-more hidden-sm-and-up" @click="$router.push('/product/st')">更多...</div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="{span:22, offset:1}" :md="{span:20, offset:2}" :lg="{span:20, offset:2}">
          <div class="product-list">
            <div class="product-item" v-for="(item, index) in product.st.slice(0, 6)" :key="index" @click="openWindow('purchase',item.id)">
              <div class="imgBox" v-if="item.pic">
                <img :src="$baseURL + '/common/service/getFile/' + item.pic" alt="">
              </div>
              <div class="titleBox">{{item.name}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </template>

  </div>
</template>

<script>
import AnnouncementBar from './AnnouncementBar.vue'

export default {
  components: {
    AnnouncementBar
  },
  data () {
    return {
      centerNews: [],
      centerAnnouncement: [],
      institutionAnnouncement: [],
      lessonType: [
        { name: '功能安全相关课程', value: 1 },
        { name: '信息安全相关课程', value: 2 },
        { name: '报警管理相关课程', value: 3 },
        { name: '软件相关课程', value: 4 },
        { name: '汽车电子相关课程', value: 5 }
      ],
      lessonList: [],
      images: {},
      product: null,
      homeCount: {}
    }
  },
  mounted () {
    this.getResource(['home_carousel', 'home_news_carousel'])
    this.getNews()
    this.getProduct()
    this.getLesson()
    this.getHomeCount()
  },
  methods: {
    getHomeCount () {
      this.$http.post('/global/service/getHomeCount').then((res) => {
        this.homeCount = res.data
      })
    },
    getResource (codes) {
      this.$http.post('/door/service/getImageByCode', codes).then((res) => {
        this.images = res.data
      })
    },
    getNews () {
      this.$http.post('/door/service/getNewsByPage', { pageNum: 1, pageSize: 13, type: 1, status: 2 }).then((res) => {
        this.centerNews = res.data.newsList
      })
      this.$http.post('/door/service/getNewsByPage', { pageNum: 1, pageSize: 8, type: 2, status: 2 }).then((res) => {
        this.centerAnnouncement = res.data.newsList
      })
      this.$http.post('/door/service/getNewsByPage', { pageNum: 1, pageSize: 8, type: 4, status: 2 }).then((res) => {
        this.institutionAnnouncement = res.data.newsList
      })
    },
    getProduct () {
      this.$http.post('/product/service/getProductByCode', ['tool', 'sfs', 'pfs', 'sis', 'cis', 'st']).then((res) => {
        this.product = res.data
      })
    },
    getLesson () {
      this.$http.post('/lesson/service/getLessonByPage', { pageNum: 1, pageSize: 10, sortBy: 'startTime' }).then((res) => {
        this.lessonList = res.data.lessonList.map((item, index) => {
          item.index = index + 1

          const infoList = JSON.parse(item.info)

          // 先按 deadline 升序
          infoList.sort((a, b) => a.deadline - b.deadline)

          if (infoList.length === 1) {
            item.detail = infoList[0]
          } else {
            const now = Date.now()
            const detail = infoList.find(info => info.deadline > now)
            item.detail = detail || infoList[infoList.length - 1]
          }
          return item
        })
      })
    },
    openWindow (path, id) {
      // const pathSegment = '/#/' + path + '/' + id
      // const fullUrl = process.env.VUE_APP_PUBLIC_PATH + pathSegment
      // window.open(fullUrl, '_blank')
      this.$router.push('/' + path + '/' + id)
    }
  }
}
</script>

<style lang="less" scoped>
.home-view {
  .home-row2 {
    background-color: #e9f8f5;
    .el-col {
      height: 50px;
      padding: 5px 10px;
      text-align: center;
      .pic {
        display: inline-block;
        vertical-align: top;
        img {
          height: 40px;
          width: 40px;
        }
      }
      .text {
        display: inline-block;
        margin-left: 10px;
        font-weight: bold;
        color: #333;
        .bottomText {
          font-size: 10px;
          line-height: 20px;
        }
      }
    }
  }
  .home-row3 {
    padding: 20px 0;
    .el-col {
      padding: 0 10px;
    }
    .content {
      overflow: hidden;
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .home-row4 {
    padding: 20px 0;
    background-color: #e9f8f5;
    .el-col {
      padding: 0 10px;
    }
    .train-content {
      height: 550px;
      overflow-y: auto;
      .listContent {
        background-color: #fff;
        padding: 20px;
        .list-item {
          position: relative;
          height: 120px;
          margin-bottom: 10px;
          cursor: pointer;
          &:hover {
            .listInfo {
              background-color: #dce1ff;
            }
          }
          &:active {
            .listInfo {
              background-color: #e9ecff;
            }
          }
          .leftText {
            position: absolute;
            top: 0;
            left: 0;
            width: 40px;
            line-height: 25px;
            padding: 10px;
            height: 100%;
            color: #fff;
            font-size: 20px;
            background-color: #315abb;
            font-weight: bold;
          }
          .listInfo {
            height: 100%;
            padding: 6px 10px 6px 45px;
            background-color: #e9ecff;
            .list-item-title {
              height: 30px;
              line-height: 30px;
              font-size: 20px;
              font-weight: bold;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .list-item-text {
              padding-left: 22px;
              height: 26px;
              line-height: 26px;
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .content {
      height: 245px;
      overflow-y: auto;
    }
  }

  .home-row5 {
    padding: 20px 0px;
    background-color: #e9ecff;
    .titleLine,
    .subTitleLine {
      padding: 0 10px;
    }
  }
  .home-row6 {
    padding: 20px 0px;
    background-color: #e9f8f5;
    .titleLine,
    .subTitleLine {
      padding: 0 10px;
    }
  }
  .home-row7 {
    padding: 20px 0px;
    background-color: #e9ecff;
    .titleLine,
    .subTitleLine {
      padding: 0 10px;
    }
  }
  .home-row8 {
    padding: 20px 0px;
    background-color: #e9f8f5;
    .titleLine,
    .subTitleLine {
      padding: 0 10px;
    }
  }

  .titleLine {
    position: relative;
    height: 60px;
    padding: 10px 0;
    .title {
      height: 40px;
      line-height: 40px;
      font-size: 24px;
      font-weight: bold;
      border-left: 10px solid #00b050;
      padding-left: 15px;
    }
    .divider {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      border-bottom: 4px solid #1dac51;
      height: 34px;
    }
    .more {
      position: absolute;
      top: 0;
      right: 0;
      height: 60px;
      line-height: 60px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      &:hover {
        color: #4155c6;
      }
    }
  }
  .subTitleLine {
    position: relative;
    height: 60px;
    padding: 10px 0;
    .devider {
      height: 24px;
      border-bottom: 4px solid #1dac51;
    }
    .title {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      text-align: center;
      height: 40px;
      line-height: 40px;
      font-size: 26px;
      font-weight: bold;
      span {
        padding: 0 20px;
        background-color: #e9f8f5;
      }
    }
  }
  .arrow-more {
    position: absolute;
    top: 0;
    right: 0;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    padding: 0 10px;
    cursor: pointer;
    &:hover {
      color: #4155c6;
    }
    i {
      border: 2px solid #4155c6;
      border-radius: 50%;
      margin: 0 10px;
      font-weight: bold;
      color: #4155c6;
    }
  }
  .news-item {
    height: 30px;
    line-height: 30px;
    position: relative;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      background-color: #00000008;
    }
    .news-item-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 90px;
    }
    .news-item-date {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .product-list {
    /* 用 Grid 代替原 flex，实现自适应分栏与自然换行 */
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(220px, 1fr)
    ); /* 卡片最小 220px，空间允许则自动加列 */
    gap: 16px 16px; /* 行/列间距 */
    max-width: 1587px; /* 保留整体最大宽度约束，可按需调整或删除 */
    margin: 0 auto;
    text-align: center;
  }

  .product-item {
    box-sizing: border-box;
    padding: 10px;
    /* 取消固定高度，让内容自适应；若需统一卡片视觉，可设置 min-height */
    min-height: 220px;
    cursor: pointer;
    user-select: none;
    transition: transform 0.3s ease; /* 将过渡放在默认态，避免布局抖动 */
    will-change: transform; /* 轻量优化 */

    .imgBox {
      /* 采用固化纵横比，避免不同图片比例导致卡片高度不齐 */
      aspect-ratio: 4 / 3; /* 4:3，可按需改为 1/1 或 16/9 */
      border: 5px solid #2f5ba9;
      border-radius: 5px;
      overflow: hidden; /* 防止图片外溢 */
      img {
        width: 100%;
        height: 100%;
        object-fit: cover; /* 居中裁剪，保证铺满 */
        display: block;
      }
    }

    .titleBox {
      margin-top: 8px;
      line-height: 22px;
      font-weight: bold;
      font-size: 16px;
      /* 若标题过长，限制行数并显示省略号 */
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 最多两行 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-word;
    }

    .subName {
      margin-top: 4px;
      font-size: 13px;
      line-height: 20px;
      color: #666;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-word;
    }

    &:hover {
      transform: scale(1.05);
    }
    &:active {
      transform: scale(1);
    }
  }

  /* 小屏时适当收紧最小列宽与间距，提高容纳度 */
  @media (max-width: 480px) {
    .product-list {
      grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
      gap: 12px;
    }
  }
}
</style>
